import { Button } from "primereact/button";
import checkPointIcon from '../../../../assets/icons/mailing/check_point_icon.svg';

const deliverySteps = [
    {
        heading: "Send your documents to the IRS",
        description: "We will send your cover letter, two copies of your 83(b) election form, and a postage-paid return envelope to the IRS."
    },
    {
        heading: "Provide a tracking number and proof of delivery",
        description: "Once your documents are shipped, we will provide you with a tracking number and proof of delivery, if and once available. If mailing with USPS Certified Mail, we will also provide you with the postmarked Certified Mail Receipt."
    },
    {
        heading: "Provide IRS date-stamped copy",
        description: "If and once received, we will provide you with the IRS date-stamped copy of your filing.",
    },
    {
        heading: "Store your documents for 90 days",
        description: "We will store any originals or digital copies of your documents for 90 days after placing your order. You may request that we mail you the originals within this period.",
    },
];

type PropTypes = {
    isPaymentEnabled: boolean;
    handlePreviousStep: () => void;
    handleNextStep: () => void;
}

function DeliveryService(props: PropTypes) {
    const {

        isPaymentEnabled,
        handlePreviousStep,
        handleNextStep,

    } = props;

    return (
        <div className="p-5 w-full h-full flex flex-column gap-2 justify-content-center align-items-center">
            <div className="p-5 h-full bg-white flex flex-column gap-2 relative" >
                <div className="overflow-y-auto h-full flex flex-column gap-2 mt-6" style={{ maxHeight: "65vh" }}>
                    <div className="mb-4">
                        <i className="pi pi-info-circle mr-2" />
                        <span className="font-medium text-2xl">
                            After you confirm the submission of your 83(b) election form, we will:
                        </span>
                    </div>
                    <ul className="list-none flex flex-column gap-2 pl-0" style={{ maxHeight: "65vh" }}>
                        {
                            deliverySteps.map((step, index) => (
                                <li key={index} className="flex align-items-start gap-3 mb-2">
                                    <img src={checkPointIcon} alt={step.heading} className="mt-2" />
                                    <div className="flex flex-column gap-2">
                                        <span className="font-semibold text-xl">{step.heading}</span>
                                        <span className="font-medium text-lg">{step.description}</span>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
            <div className="w-full mt-auto px-2 flex justify-content-end gap-2 bg-white">
                <Button label="Back"
                    severity="secondary"
                    onClick={handlePreviousStep} />
                <Button label={isPaymentEnabled ? "Pay" : "Submit"}
                    onClick={handleNextStep} />
            </div>
        </div>
    );
}

export default DeliveryService;